export default {
  methods: {
    switchState(params, cbParams, action) {
      const loading = this.$loading({
        target: '.app-main',
        lock: true,
      });
      this.$q.newProduct.switchProcessState(params)
        .then(({success}) => {
          if (success) {
            this.$notify.success({
              title: '成功',
              message: `${action}成功`,
            });
            this.updateAfterOperation(cbParams);
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    // 终止
    terminateTask(skuId, skuCode, taskId, spuId) {
      this.$confirm((<div class="jsx-content">
        确认后，SKU将无法完成进度更新！
        <span style="color: #E63946; margin-top: 5px;">
          
        </span>
      </div>), '确认终止')
      .then(_=>{
        const params = {
          data: {
            skuId,
            taskId,
          }
        };
        this.switchState(params, {skuId, skuCode}, '终止');
      })
      .catch(_=> {});
    },
    restartTask(skuId, skuCode, taskId, taskName, spuId) {
      this.$confirm((<div class="jsx-content">
        确认重启，原有流程已进行到“{taskName}”，可选择：
        <p style="margin-top:5px;">1. 点击“继续”操作，从之前节点继续更新</p>
        <p>2. 点击“重启”操作，清空数据，从“新品上架”开始</p>
        <span style="color: #E63946; margin-top: 5px;">
          
        </span>
      </div>), '重启', {
        cancelButtonText: '重启',
        confirmButtonText: '继续',
        cancelButtonClass: 'el-button--primary'
      })
      .then(_=>{
        const params = {
          data: {
            skuId,
            taskId,
            type: 1,
            spuId
          }
        };
        this.switchState(params, {skuId, skuCode}, '重启');
      })
      .catch(_=> {
        const params = {
          data: {
            skuId,
            taskId,
            type: 0,
            spuId
          }
        };
        this.switchState(params, {skuId, skuCode}, '重启');
      });
    }
  }
}